import { render } from "./VideoMyAdvList.vue?vue&type=template&id=24ade960&scoped=true"
import script from "./VideoMyAdvList.vue?vue&type=script&lang=js"
export * from "./VideoMyAdvList.vue?vue&type=script&lang=js"

import "./VideoMyAdvList.vue?vue&type=style&index=0&id=24ade960&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ade960"]])

export default __exports__